var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeColumnsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16663,
    y: 1,
    width: 3.88889,
    height: 14,
    rx: 0.5,
    stroke: "#A93E71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.05554,
    y: 1,
    width: 3.88889,
    height: 14,
    rx: 0.5,
    fill: "#FFFAFC",
    stroke: "#A93E71"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9445,
    y: 1,
    width: 3.88889,
    height: 14,
    rx: 0.5,
    stroke: "#A93E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeColumnsIcon);
export default __webpack_public_path__ + "static/media/changeColumnsIcon.bc67f5787217fad5d132703be7f1f931.svg";
export { ForwardRef as ReactComponent };